export default "__VITE_ASSET__BhSseQU0__"